// 사이트탐색알림(중고거래) 알림이력 화면 (tb_marketplace_alert_history)
// 발송된 알림 목록 조회, 매물 제목 클릭 시 원본 게시글을 새 탭으로 이동
import React, { useState, useCallback, useEffect } from 'react';
import { fetchAlertHistory } from '../../api/marketplace';
import PageLayout from '../../components/PageLayout';
import './MarketplaceAlertHistoryPage.css';

const PAGE_SIZE = 20;

const SITE_LABEL = { WASSADA: '와싸다', SORIAUDIO: '소리전자' };

const fmtPrice = (price) => (price != null ? `${Number(price).toLocaleString()}원` : '-');

const MarketplaceAlertHistoryPage = () => {
  const [history, setHistory] = useState({ data: [], total: 0, page: 1 });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const loadHistory = useCallback(async (page) => {
    setLoading(true);
    try {
      const res = await fetchAlertHistory(page, PAGE_SIZE);
      setHistory({ data: res.data || [], total: res.total || 0, page });
    } catch {
      setMessage({ text: '알림이력 조회에 실패했습니다.', type: 'error' });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadHistory(1); }, [loadHistory]);

  const totalPages = Math.ceil(history.total / PAGE_SIZE);

  return (
    <PageLayout title="알림이력" message={message}>
      <div className="mh-panel">
        <div className="grid-wrapper">
          <table className="grid-table">
            <thead>
              <tr>
                <th className="col-center" style={{ width: 90 }}>발견시각</th>
                <th className="col-center" style={{ width: 70 }}>사이트</th>
                <th>제목</th>
                <th className="col-right" style={{ width: 100 }}>가격</th>
                <th className="col-center" style={{ width: 80 }}>지역</th>
                <th className="col-center" style={{ width: 90 }}>발송여부</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="grid-empty">조회중...</td></tr>}
              {!loading && history.data.length === 0 && (
                <tr><td colSpan={6} className="grid-empty">알림이력이 없습니다.</td></tr>
              )}
              {history.data.map((row) => (
                <tr key={row.id}>
                  <td className="col-center">{row.matched_at}</td>
                  <td className="col-center">{SITE_LABEL[row.site_code] || row.site_code}</td>
                  <td>
                    <a href={row.post_url} target="_blank" rel="noopener noreferrer" className="mh-title-link">
                      {row.title}
                    </a>
                  </td>
                  <td className="col-right">{fmtPrice(row.price)}</td>
                  <td className="col-center">{row.post_region || '-'}</td>
                  <td className="col-center">
                    {row.sent_at ? <span className="mh-sent-ok">발송완료</span> : <span className="mh-sent-fail">미발송</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="mh-paging">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                className={`mh-page-btn${p === history.page ? ' active' : ''}`}
                onClick={() => loadHistory(p)}
              >
                {p}
              </button>
            ))}
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default MarketplaceAlertHistoryPage;
